import React from "react";

export const Newsletter = () => {
  return (
    <div className="letter-container">
              <h1>Sign up for our newsletter to receive 
                  special offers , news and great events
              </h1>
              <input id="input" placeholder="Email"/> <button className="primay-btn label-btn pointer">Subscribe</button>
    </div>
  )
}

